import React, { useEffect, useRef, useState } from "react";
import MuiTextField from "@mui/material/TextField";
import useKeyboard from "@shared/modules/utils/Keyboard/useKeyboard";
import EventService from "@shared/services/EventService";
import { scrollFieldIntoViewIfHidden } from "@shared/modules/utils/FormField/constants";
import "@app/stylesV2/components/FromField/from_field.scss"
const TextField2 = React.forwardRef(
    (
        {
            label,
            errorMsg,
            value,
            onChangeInput,
            sizeRange,
            allowedSizes,
            containerClass,
            showKeyboard = true,
            enableScrollFieldIfHiddenEvent = true,
            virtualKeyboardLayout = null,
            virtualKeyboardLang = "en2",
            themeName="alphanumeric",
            ...restProps
        },
        ref
    ) => {
        const [brVal, setBrVal] = useState(true);
        const [focus, setFocus] = useState(false);
        const [position, setPosition] = useState(0);

        const focusRef = useRef(false); //focus state is "stale" in subscribe event

        useEffect(() => {
            let eventInput = EventService.subscribe("keypad.blur", bool => {
                setBrVal(bool);
            });

            let scrollEvent = enableScrollFieldIfHiddenEvent
                ? EventService.subscribe("keyboard.show",() => {
                    if (focusRef.current) {
                        scrollFieldIntoViewIfHidden(ref);
                    }})
                : {};

            return () => {
                eventInput.remove();
                if (scrollEvent.remove) scrollEvent.remove();
            };
        });

        const handleInputChange = newValue => {
            if (!isValid(newValue) || !ref.current) return;

            const cursorPosition =
                newValue.length > value.length
                    ? ref.current.selectionEnd + 1
                    : ref.current.selectionEnd - 1 >= 0
                    ? ref.current.selectionEnd - 1
                    : 0;
            setPosition(cursorPosition);
            let finalValue = newValue;

            if (typeof cursorPosition === "number" && cursorPosition >= 0 && value.length > cursorPosition) {
                const isInsert = newValue.length > value.length;
                const isDelete = newValue.length < value.length;

                if (isInsert) {
                    const insertedChar = newValue.slice(-1);
                    finalValue = value.slice(0, cursorPosition - 1) + insertedChar + value.slice(cursorPosition - 1);
                } else if (isDelete) {
                    finalValue = value.slice(0, cursorPosition) + value.slice(cursorPosition + 1);
                }

                // console.log({
                //     value,
                //     newValue,
                //     finalValue,
                //     cursorPosition,
                //     isInsert,
                //     isDelete
                // });
            }

            onChangeInput(finalValue);
        };

        const handelBlur = () => {
            if (brVal) {
                EventService.publish("keyboard.hide");
                setFocus(false);
                focusRef.current = false;
            } else {
                ref.current.focus();
                ref.current.selectionStart = position;
                ref.current.selectionEnd = position;
                setBrVal(true);
                setFocus(true);
                focusRef.current = true;
            }
        };

        const isValid = value => {
            if (sizeRange) {
                let max = sizeRange[1];
                if (max !== -1 && String(value).split(".")[0].length > max) {
                    return false;
                }
            }

            if (allowedSizes && allowedSizes.length !== 0) {
                let largest = Math.max(...allowedSizes);
                if (String(value).length > largest) return false;
            }

            return true;
        };

        const { openKeyboard } = useKeyboard(value, handleInputChange);
        return (
            <div
                className={`from-field-amx ${errorMsg ? "error-field" : ""} ${focus ? "blurFocus" : ""} ${
                    containerClass || ""
                }`}
            >
                <MuiTextField
                    inputRef={ref}
                    label={label}
                    value={value}
                    bottomLineColor="#00ae42"
                    onChange={e => handleInputChange(e.target.value)}
                    onFocus={() => {
                        setFocus(true);
                        focusRef.current = true;
                        showKeyboard &&
                            openKeyboard({
                                layoutName: virtualKeyboardLayout || "shift",
                                virtualKeyboardLang: virtualKeyboardLang,
                                themeName:virtualKeyboardLang ==="ar"? "arabic" : themeName,
                                value
                            });
                    }}
                    variant="standard"
                    {...restProps}
                    onBlur={handelBlur}
                />
                {errorMsg && <span className="helperTextError">{errorMsg}</span>}
            </div>
        );
    }
);

export default TextField2;
